<script>
    import { colours } from '../services/colours.js';
    import { fade } from 'svelte/transition';

</script>

<div class="spinner" transition:fade>
    <div class="red" style="border-color: {$colours.red}"></div>
    <div class="green" style="border-color: {$colours.green}"></div>
    <div class="blue" style="border-color: {$colours.primaryBlue}"></div>
    <div class="orange" style="border-color: {$colours.orange}"></div>
</div>

<style>
    .spinner {
        position: absolute;
        left: calc(50% - 1rem);
        top: calc(50% - 0.5rem);
    }
    .spinner>div {
        position: absolute;
        width: 2rem;
        height: 1rem;
        border-radius: 50%;
        display: inline-block;
        border-width: 1px;
        border-style: solid;
        animation: spin 4s ease-in-out infinite;
    }
    .spinner>div:nth-child(1n) {
        --offset: 0deg
    }
    .spinner>div:nth-child(2n) {
        --offset: 45deg
    }
    .spinner>div:nth-child(3n) {
        --offset: 90deg
    }
    .spinner>div:nth-child(4n) {
        --offset: 135deg
    }

    @keyframes spin {
        0% {
            transform: rotate(var(--offset));
        }
        100% {
            transform: rotate(calc(360deg + var(--offset)));
        }
    }
</style>